import React from "react";

import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";

const DatePickerField = (props) => {
  const { field, form, label } = props;

  let otherProps = {};

  if (form.errors[field.name] && form.touched[field.name]) {
    otherProps.helperText = form.errors[field.name];
    otherProps.error = true;
  }

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <KeyboardDatePicker
        variant="inline"
        inputVariant="outlined"
        format="MM/dd/yyyy"
        margin="normal"
        label={label}
        value={field.value}
        onChange={(e) => {
          form.setFieldValue(field.name, e);
        }}
        autoOk
        style={{ width: "100%" }}
        {...props.formControlStyle}
        {...otherProps}
      />
    </MuiPickersUtilsProvider>
  );
};

export default DatePickerField;



// WEBPACK FOOTER //
// ./src/components/DatePickerField.js